/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1276
 */

var r = require(/* 634 */"../1774/1253/634")
module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(r)
